import React from "react";
import { Link } from "react-router-dom";

const settingsItems = [
  { 
    name: "Hållbarhetsmål", 
    icon: "Innehåll", 
    link: "/settings",
    description: "Hantera dina hållbarhetsmål och mål"
  },
  { 
    name: "Certifieringar & märkningar", 
    icon: "Innehåll", 
    link: "/settings",
    description: "Hantera certifieringar och kvalitetsmärkningar"
  },
  { 
    name: "Info om restaurangen", 
    icon: "Innehåll", 
    link: "/settings",
    description: "Uppdatera restauranginformation och profil"
  },
  { 
    name: "Ursprungsländer", 
    icon: "Innehåll", 
    link: "/settings",
    description: "Hantera ursprungsländer för ingredienser"
  },
  { 
    name: "Ingredienser", 
    icon: "Innehåll", 
    link: "/settings",
    description: "Hantera ingrediensdatabas och källor"
  },
];

const profile = {
  name: "Lab Consupedia",
  profileInfo: [
    { name: "Adress", value: "Torsgatan 10, Stockholm" },
    {
      name: "Hemsida",
      value: "https://consupedia.com",
    },
    { name: "Mail", value: "info@consupedia.com" },
    { name: "Telefon", value: "08-xx-xx-xx-xx" },
  ],
};

const SettingsPage = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 tablet:px-6 laptop:px-8 desktop:px-8 py-8">
        {/* Header */}
        <div className="mb-6 mobile:mb-8 tablet:mb-8 laptop:mb-8 desktop:mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl mobile:text-3xl tablet:text-4xl laptop:text-4xl desktop:text-4xl font-bold text-gray-900 mb-2 mobile:mb-3 tablet:mb-3 laptop:mb-3 desktop:mb-3">Inställningar</h1>
              <p className="text-sm mobile:text-base tablet:text-lg laptop:text-lg desktop:text-lg text-gray-600">
                Hantera dina kontoinställningar och preferenser
              </p>
            </div>
            <Link 
              to="/" 
              className="bg-white hover:bg-gray-50 text-gray-700 font-semibold py-2 mobile:py-3 tablet:py-3 laptop:py-3 desktop:py-3 px-4 mobile:px-6 tablet:px-6 laptop:px-6 desktop:px-6 rounded-lg mobile:rounded-xl tablet:rounded-xl laptop:rounded-xl desktop:rounded-xl border border-gray-200 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-secondary-green focus:ring-offset-2 transform hover:scale-[1.02] active:scale-[0.98] text-sm mobile:text-sm tablet:text-sm laptop:text-sm desktop:text-sm"
            >
              Tillbaka till Dashboard
            </Link>
          </div>
        </div>

        {/* Settings Grid */}
        <div className="grid grid-cols-1 mobile:grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 gap-6 mobile:gap-8 tablet:gap-8 laptop:gap-8 desktop:gap-8 mb-8 mobile:mb-12 tablet:mb-12 laptop:mb-12 desktop:mb-12">
          {settingsItems.map((item, index) => (
            <div key={index} className="bg-white rounded-xl mobile:rounded-2xl tablet:rounded-2xl laptop:rounded-2xl desktop:rounded-2xl shadow-sm border border-gray-100 p-6 mobile:p-8 tablet:p-8 laptop:p-8 desktop:p-8 hover:shadow-md transition-all duration-300 transform hover:scale-[1.02]">
              <div className="flex items-center mb-4 mobile:mb-6 tablet:mb-6 laptop:mb-6 desktop:mb-6">
                <div className="w-12 h-12 mobile:w-16 mobile:h-16 tablet:w-16 tablet:h-16 laptop:w-16 laptop:h-16 desktop:w-16 desktop:h-16 bg-gradient-to-br from-secondary-green/20 to-secondary-green/30 rounded-xl mobile:rounded-2xl tablet:rounded-2xl laptop:rounded-2xl desktop:rounded-2xl flex items-center justify-center mr-4 mobile:mr-6 tablet:mr-6 laptop:mr-6 desktop:mr-6">
                  <img 
                    src="/assets/icons/Innehall.png" 
                    alt="Settings" 
                    className="w-6 h-6 mobile:w-8 mobile:h-8 tablet:w-8 tablet:h-8 laptop:w-8 laptop:h-8 desktop:w-8 desktop:h-8"
                  />
                </div>
                <div>
                  <h3 className="text-lg mobile:text-xl tablet:text-xl laptop:text-xl desktop:text-xl font-bold text-gray-900">{item.name}</h3>
                  <p className="text-sm mobile:text-base tablet:text-base laptop:text-base desktop:text-base text-gray-600">{item.description}</p>
                </div>
              </div>
              <Link 
                to={item.link}
                className="inline-flex items-center text-secondary-green hover:text-secondary-green/80 font-semibold transition-colors duration-200"
              >
                Hantera
                <img 
                  src="/assets/icons/arrow_right.png" 
                  alt="Go to" 
                  className="w-4 h-4 ml-2"
                />
            </Link>
            </div>
          ))}
        </div>

        {/* Profile Card */}
        <div className="bg-white rounded-xl mobile:rounded-2xl tablet:rounded-2xl laptop:rounded-2xl desktop:rounded-2xl shadow-sm border border-gray-100 p-6 mobile:p-8 tablet:p-8 laptop:p-8 desktop:p-8">
          <div className="flex items-center mb-6 mobile:mb-8 tablet:mb-8 laptop:mb-8 desktop:mb-8">
            <div className="w-16 h-16 mobile:w-20 mobile:h-20 tablet:w-20 tablet:h-20 laptop:w-20 laptop:h-20 desktop:w-20 desktop:h-20 bg-gradient-to-br from-secondary-green/20 to-secondary-green/30 rounded-xl mobile:rounded-2xl tablet:rounded-2xl laptop:rounded-2xl desktop:rounded-2xl flex items-center justify-center mr-4 mobile:mr-6 tablet:mr-6 laptop:mr-6 desktop:mr-6">
              <img 
                src="/assets/icons/Innehall.png" 
                alt="User" 
                className="w-8 h-8 mobile:w-10 mobile:h-10 tablet:w-10 tablet:h-10 laptop:w-10 laptop:h-10 desktop:w-10 desktop:h-10"
              />
            </div>
            <div>
              <h2 className="text-xl mobile:text-2xl tablet:text-2xl laptop:text-2xl desktop:text-2xl font-bold text-gray-900">{profile.name}</h2>
              <p className="text-gray-600 mb-4">Hantera dina kontoinställningar och preferenser</p>
            </div>
          </div>

          <div className="grid grid-cols-1 mobile:grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-2 desktop:grid-cols-2 gap-4 mobile:gap-6 tablet:gap-6 laptop:gap-6 desktop:gap-6">
            {profile.profileInfo.map((info, index) => (
              <div key={index} className="flex items-center justify-between p-4 mobile:p-6 tablet:p-6 laptop:p-6 desktop:p-6 bg-gray-50 rounded-lg mobile:rounded-xl tablet:rounded-xl laptop:rounded-xl desktop:rounded-xl">
                <span className="text-sm mobile:text-base tablet:text-base laptop:text-base desktop:text-base font-medium text-gray-700">{info.name}</span>
                <span className="text-sm mobile:text-base tablet:text-base laptop:text-base desktop:text-base text-gray-600">{info.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
